import { render, staticRenderFns } from "./DeleteTestButton.vue?vue&type=template&id=79a298e4&"
import script from "./DeleteTestButton.vue?vue&type=script&lang=js&"
export * from "./DeleteTestButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports